<template>
    <v-text-field v-model="message" v-bind="{ loading }" flat solo hide-details @keydown.enter="sendMessage">
        <template #append>
            <v-btn v-bind="{ loading }" small text icon class="mr-n8" @click="sendMessage">
                <v-icon>mdi-send</v-icon>
            </v-btn>
        </template>
    </v-text-field>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    data: () => ({
        message: null,
    }),
    computed: {
        ...mapState("lecture/chat", ["loading"]),
    },
    methods: {
        ...mapActions("lecture/chat", ["chat"]),
        sendMessage() {
            this.chat(this.message);
            this.message = null;
        },
    },
};
</script>

<style>
</style>